import { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import ResumenCotizacion from "./ResumenCotizacion";
import {
  actualizarObservaciones,
  actualizarDespacho,
} from "../../../service/AffariService";
import { useGlobalContext } from "../../../Config";
import { useOffline } from "../../../offline/OfflineContext.js";
import { actualizarCotizacionOffline } from "../../../offline/offlineCotizacionService.js";

const ObservacionesEntregaResumen = ({
  data,
  setData,
  idCotizacion,
  notify,
  resumen,
  setResumen,
  onChangeCondicionEntrega,
  onRefresh,
}) => {
  const { offlineMode } = useOffline();
  const [despachoSaved, setDespachoSaved] = useState({
    direccion: false,
    referencia: false,
    comuna: false,
  });
  const [loadingDespacho, setLoadingDespacho] = useState({
    direccion: false,
    referencia: false,
    comuna: false,
  });
  const { isSack, isDinar } = useGlobalContext();
  const commitDespacho = async (nextData, field) => {
    if (!idCotizacion) {
      if (notify)
        notify("warn", "Cotización", "ID de cotización no disponible");
      return;
    }
    try {
      setLoadingDespacho((prev) => ({ ...prev, [field]: true }));

      if (offlineMode) {
        await actualizarCotizacionOffline(idCotizacion, {
          direccionDespacho:
            nextData.direccionDespacho ?? nextData?.cliente?.direccion ?? "",
          referenciaDespacho: nextData.referenciaDespacho ?? "",
          comunaDespacho:
            nextData.comunaDespacho ?? nextData?.cliente?.comuna?.codigo ?? null,
        });
      } else {
        await actualizarDespacho(
          idCotizacion,
          true,
          nextData.comunaDespacho ?? nextData?.cliente?.comuna?.codigo ?? null,
          nextData.direccionDespacho ?? nextData?.cliente?.direccion ?? null,
          nextData.referenciaDespacho ?? null,
        );
        if (field === "comuna" && onRefresh) {
          await onRefresh();
        }
      }
      setDespachoSaved((prev) => ({ ...prev, [field]: true }));
    } catch (error) {
      setDespachoSaved((prev) => ({ ...prev, [field]: false }));
      if (notify)
        notify("error", "Error actualizando despacho", error.message || "");
    } finally {
      setLoadingDespacho((prev) => ({ ...prev, [field]: false }));
    }
  };

  const handleDespachoChange = (updates, field) => {
    setDespachoSaved((prev) => ({ ...prev, [field]: false }));
    setLoadingDespacho((prev) => ({ ...prev, [field]: false }));
    setData((prev) => ({ ...prev, ...updates }));
  };

  const handleDespachoCommit = (updates, field) => {
    setData((prev) => {
      const nextData = { ...prev, ...updates };
      commitDespacho(nextData, field);
      return nextData;
    });
  };

  return (
    <div className="grid">
      <div className="col-12 md:col-4">
        <label
          htmlFor="observaciones"
          className="text-500 font-medium text-xs block mb-1"
        >
          Observaciones
        </label>
        <InputTextarea
          id="observaciones"
          value={data.observaciones || ""}
          onChange={(e) => setData({ ...data, observaciones: e.target.value })}
          onBlur={async (e) => {
            try {
              if (!idCotizacion) {
                if (notify)
                  notify(
                    "warn",
                    "Cotización",
                    "ID de cotización no disponible",
                  );
                return;
              }

              if (offlineMode) {
                await actualizarCotizacionOffline(idCotizacion, {
                  observaciones: e.target.value,
                });
              } else {
                await actualizarObservaciones(idCotizacion, e.target.value);
              }

              if (notify) notify("success", "Observaciones actualizadas", "");
            } catch (error) {
              if (notify)
                notify(
                  "error",
                  "Error actualizando observaciones",
                  error.message || "",
                );
            }
          }}
          className="w-full p-inputtext-sm"
          style={{ minHeight: "150px", height: "90%" }}
        />
      </div>

      {isSack && (
        <div className="col-12 md:col-4">
          <div className="flex flex-column lg:flex-row gap-2 h-full">
            <fieldset
              className="border-1 border-300 p-2 border-round surface-0 flex flex-column gap-2"
              style={{ minWidth: "140px" }}
            >
              <legend className="text-500 font-medium text-xs px-1">
                Condición de Entrega
              </legend>
              <div className="flex align-items-center gap-2">
                <RadioButton
                  inputId="condicionRetiro"
                  name="condicionEntrega"
                  value="RETIRO"
                  onChange={(e) => onChangeCondicionEntrega(e.value)}
                  checked={(data.condicionEntrega || "RETIRO") === "RETIRO"}
                />
                <label htmlFor="condicionRetiro" className="text-sm">
                  RETIRO
                </label>
              </div>
              <div className="flex align-items-center gap-2">
                <RadioButton
                  inputId="condicionDespacho"
                  name="condicionEntrega"
                  value="DESPACHO"
                  onChange={(e) => onChangeCondicionEntrega(e.value)}
                  checked={data.condicionEntrega === "DESPACHO"}
                />
                <label htmlFor="condicionDespacho" className="text-sm">
                  DESPACHO
                </label>
              </div>
            </fieldset>
            {data.condicionEntrega === "DESPACHO" && (
              <fieldset className="border-1 border-300 p-2 border-round surface-0 flex-1">
                <legend className="text-500 font-medium text-xs px-1">
                  Dirección de Despacho
                </legend>
                <div className="flex align-items-center gap-2 mb-2">
                  <Checkbox
                    inputId="cambiarDireccion"
                    checked={data.cambiarDireccion || false}
                    onChange={(e) =>
                      setData({ ...data, cambiarDireccion: e.checked })
                    }
                  />
                  <label htmlFor="cambiarDireccion" className="text-xs">
                    cambiar dirección de despacho
                  </label>
                </div>
                <div className="flex flex-column gap-2">
                  <div className="flex align-items-center gap-2">
                    <label htmlFor="direccion" className="text-xs w-4rem">
                      Dirección
                    </label>
                    <InputText
                      id="direccion"
                      value={
                        data.direccionDespacho || data?.cliente?.direccion || ""
                      }
                      onChange={(e) =>
                        handleDespachoChange(
                          { direccionDespacho: e.target.value },
                          "direccion",
                        )
                      }
                      onBlur={(e) =>
                        handleDespachoCommit(
                          { direccionDespacho: e.target.value },
                          "direccion",
                        )
                      }
                      className="p-inputtext-sm flex-1 h-2rem"
                      disabled={!data.cambiarDireccion}
                    />
                    {loadingDespacho.direccion ? (
                      <i className="pi pi-spin pi-spinner"></i>
                    ) : null}
                    {despachoSaved.direccion ? (
                      <i className="pi pi-check-circle"></i>
                    ) : null}
                  </div>
                  <div className="flex align-items-center gap-2">
                    <label htmlFor="referencia" className="text-xs w-4rem">
                      Referencia
                    </label>
                    <InputText
                      id="referencia"
                      value={data.referenciaDespacho || ""}
                      onChange={(e) =>
                        handleDespachoChange(
                          { referenciaDespacho: e.target.value },
                          "referencia",
                        )
                      }
                      onBlur={(e) =>
                        handleDespachoCommit(
                          { referenciaDespacho: e.target.value },
                          "referencia",
                        )
                      }
                      className="p-inputtext-sm flex-1 h-2rem"
                      disabled={!data.cambiarDireccion}
                    />
                    {loadingDespacho.referencia ? (
                      <i className="pi pi-spin pi-spinner"></i>
                    ) : null}
                    {despachoSaved.referencia ? (
                      <i className="pi pi-check-circle"></i>
                    ) : null}
                  </div>
                  <div className="flex align-items-center gap-2">
                    <label htmlFor="comuna" className="text-xs w-4rem">
                      Comuna
                    </label>
                    <Dropdown
                      id="comuna"
                      value={
                        data.comunaDespacho ??
                        data?.cliente?.comuna?.codigo ??
                        null
                      }
                      options={data?.comunas || []}
                      optionLabel="descripcion"
                      optionValue="codigo"
                      onChange={(e) =>
                        handleDespachoChange(
                          { comunaDespacho: e.value },
                          "comuna",
                        )
                      }
                      onBlur={() => handleDespachoCommit({}, "comuna")}
                      className="p-inputtext-sm flex-1 h-2rem"
                      placeholder="Seleccione"
                      disabled={!data.cambiarDireccion}
                    />
                    {loadingDespacho.comuna ? (
                      <i className="pi pi-spin pi-spinner"></i>
                    ) : null}
                    {despachoSaved.comuna ? (
                      <i className="pi pi-check-circle"></i>
                    ) : null}
                  </div>
                </div>
              </fieldset>
            )}
          </div>
        </div>
      )}
      <div className="col-12 md:col-4 flex justify-content-end">
        <ResumenCotizacion
          resumen={resumen}
          setResumen={setResumen}
          idCotizacion={idCotizacion}
          notify={notify}
          condicionEntrega={data.condicionEntrega || "RETIRO"}
          descuentoTotal={Number(data.descuentoTotal || 0)}
          onDescuentoTotalChange={(value) =>
            setData((prev) => ({ ...prev, descuentoTotal: value }))
          }
          onRefresh={onRefresh}
        />
      </div>
    </div>
  );
};

export default ObservacionesEntregaResumen;
